export default {
  /**
   * Create tour
   * */
  MAX_NUMBER_OF_IMAGES: 5,
  MAX_IMAGE_SIZE:       5, // MB
  MAX_VIDEO_SIZE:       100, // MB
  VIDEO_FORMAT: {
    avi: 'avi',
    mp4: 'mp4',
    webm: 'webm',
    quicktime: 'mov'
  },
  TOUR:{
    CREATE_MAX_AVL_DATES: 5,
    CREATE_MIN_AVL_DATES: 1,
    MAX_PERSONS: 10,
  }

}


// WEBPACK FOOTER //
// ./src/app/config/validation.js